import { AnimatePresence, motion } from "framer-motion";
import { X, CalendarDays, Clock, Tag, History } from "lucide-react";
import { getShowStatus } from "@/data/content";

export default function ShowModal({ show, onClose }) {
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    key="show-modal"
                    data-testid="show-modal"
                    className="fixed inset-0 z-[90] flex items-center justify-center p-4 sm:p-6"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <div className="absolute inset-0 bg-[#0F0F23]/85 backdrop-blur-md" onClick={onClose} />
                    <motion.div
                        initial={{ y: 48, opacity: 0, scale: 0.96 }}
                        animate={{ y: 0, opacity: 1, scale: 1 }}
                        exit={{ y: 24, opacity: 0, scale: 0.97 }}
                        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                        className="relative w-full max-w-2xl overflow-hidden rounded-3xl border border-white/10 bg-[#16162B] shadow-2xl shadow-black/60"
                    >
                        <div className="relative aspect-video w-full overflow-hidden">
                            <img src={show.img} alt={show.title} className="h-full w-full object-cover" />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#16162B] via-transparent to-transparent" />
                        </div>
                        <button
                            type="button"
                            data-testid="show-modal-close"
                            onClick={onClose}
                            aria-label="Close"
                            className="absolute right-4 top-4 rounded-full bg-[#0F0F23]/70 p-2 text-white backdrop-blur transition-colors hover:bg-[#C8102E]"
                        >
                            <X size={18} />
                        </button>
                        <div className="p-6 sm:p-8">
                            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#FFA200]">
                                <Tag size={12} /> {show.category}
                            </span>
                            <h3 className="font-display mt-2 text-2xl font-black text-white sm:text-3xl">{show.title}</h3>
                            <div className="mt-3 flex flex-wrap gap-4 text-sm text-[#9999BB]">
                                <span className="inline-flex items-center gap-1.5"><CalendarDays size={14} className="text-[#C8102E]" /> {show.days}</span>
                                <span className="inline-flex items-center gap-1.5"><Clock size={14} className="text-[#C8102E]" /> {show.time}</span>
                                {(() => {
                                    const st = getShowStatus(show.slug);
                                    return st ? (
                                        <span data-testid="show-modal-status" className={`inline-flex items-center gap-1.5 font-semibold ${st.type === "live" ? "text-[#E85050]" : st.type === "upcoming" ? "text-[#FFA200]" : "text-[#9999BB]"}`}>
                                            <History size={14} /> {st.label}
                                        </span>
                                    ) : null;
                                })()}
                            </div>
                            <p className="mt-4 text-sm leading-relaxed text-[#C9C9DE] sm:text-base">{show.desc}</p>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
